(function () {
  if (customElements.get('sotm-gift')) return;

  class SotmGift extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-sotm-form]');
      this.select = this.querySelector('[data-sotm-variant]');
      this.submit = this.querySelector('[data-sotm-submit]');
      this.message = this.querySelector('[data-sotm-message]');
      this.onKeydown = (event) => { if (event.key === 'Escape') this.close(); };

      this.querySelectorAll('[data-sotm-close]').forEach((el) => {
        el.addEventListener('click', () => this.close());
      });

      this.form.addEventListener('submit', (event) => this.onSubmit(event));

      document.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-sotm-gift-open]');
        if (trigger) { event.preventDefault(); this.open(); }
      });

      const param = this.dataset.param || 'cadeau';
      if (new URLSearchParams(window.location.search).get(param) !== null) this.open();
    }

    open() {
      this.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', this.onKeydown);
    }

    close() {
      this.hidden = true;
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', this.onKeydown);
    }

    setMessage(text, isError) {
      this.message.textContent = text || '';
      this.message.hidden = !text;
      this.message.classList.toggle('sotm-gift__message--error', Boolean(isError));
    }

    async onSubmit(event) {
      event.preventDefault();

      const id = this.select.value;
      if (!id) {
        this.setMessage(this.dataset.errorSelect, true);
        this.select.focus({ preventScroll: true });
        return;
      }

      this.submit.disabled = true;
      this.setMessage('', false);

      try {
        await this.removeExisting();

        const response = await fetch(this.dataset.addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(id), quantity: 1, properties: { _is_gift: 'true', _gift_badge: 'Offert' } }]
          })
        });

        if (!response.ok) throw new Error('add failed');

        this.setMessage(this.dataset.success, false);
        window.setTimeout(() => { window.location.href = this.dataset.cartUrl; }, 800);
      } catch (error) {
        this.submit.disabled = false;
        this.setMessage(this.dataset.errorAdd, true);
      }
    }

    async removeExisting() {
      const handle = this.dataset.handle;
      const cart = await fetch(this.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const existing = (cart.items || []).filter((item) => item.handle === handle);

      for (const item of existing) {
        await fetch(this.dataset.changeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 0 })
        });
      }
    }
  }

  customElements.define('sotm-gift', SotmGift);
})();